(function() {
    'use strict';

    angular.module('product')
        .controller('ExclusionUpdateController', ExclusionUpdateController);

    ExclusionUpdateController.$inject = ['$state', 'productOptionExclusionDataSrvc', 'productOptionDataSrvc', 'notificationSrvc', 'exclusionMessagesConst', 'errorNotificationSrvc'];

    function ExclusionUpdateController($state, productOptionExclusionDataSrvc, productOptionDataSrvc, notificationSrvc, exclusionMessagesConst, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            option_1: [],
            option_2: [],
            nonFieldErrors: []
        };
        self.exclusionData = {};
        self.options = [];

        self.updateExclusion = updateExclusion;
        self.cleanErrors = cleanErrors;

        activate();

        function activate() {
            getExclusion();
            getOptions();
        }

        function getExclusion() {
            return productOptionExclusionDataSrvc.list({
                pk: $state.params.pk
            }).$promise.then(function(response) {
                self.exclusionData = response;
                delete self.exclusionData.date_added;
                delete self.exclusionData.date_modified;
                delete self.exclusionData.last_modified_by;
                return response;
            });
        }

        function getOptions() {
            return productOptionDataSrvc.productOptions()
                .$promise.then(function(response) {
                    self.options = response;
                    return response;
                });
        }

        function updateExclusion() {
            productOptionExclusionDataSrvc.update({
                pk: $state.params.pk
            }, self.exclusionData).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", exclusionMessagesConst.update);
                    $state.go('layout.category.list');
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
